import { useTranslation } from 'next-i18next'
import { Icon } from '@captaincause/ui/Icon'
import { tm } from '@captaincause/ui/tm'
import type { IconKeys } from '@captaincause/ui/Icon'
import type { Resources } from 'i18n-type'

interface ImpactItem {
  color: string
  icon: IconKeys
  content: keyof Resources['ten-millions.block']
}

const impacts1: ImpactItem[] = [
  {
    color: 'blue',
    icon: 'drop',
    content: '10m.impact6',
  },
  {
    color: 'medium-beige',
    icon: 'book',
    content: '10m.impact7',
  },
  {
    color: 'green',
    icon: 'apple',
    content: '10m.impact8',
  },
  {
    color: 'purple',
    icon: 'christmas-tree',
    content: '10m.impact9',
  },
  {
    color: 'orange',
    icon: 'tree',
    content: '10m.impact10',
  },
  {
    color: 'red',
    icon: 'waste-bin',
    content: '10m.impact11',
  },
]

const impacts2: ImpactItem[] = [
  {
    color: 'green',
    icon: 'apple',
    content: '10m.impact1',
  },
  {
    color: 'orange',
    icon: 'soap',
    content: '10m.impact2',
  },
  {
    color: 'blue',
    icon: 'drop',
    content: '10m.impact3',
  },
  {
    color: 'purple',
    icon: 'christmas-tree',
    content: '10m.impact4',
  },
  {
    color: 'medium-beige',
    icon: 'trash',
    content: '10m.impact5',
  },
  {
    color: 'red',
    icon: 'animal-foot',
    content: '10m.impact6',
  },
]

const ImpactRow = ({
  impacts,
  className = '',
}: {
  impacts: ImpactItem[]
  className?: string
}) => {
  const { t } = useTranslation('ten-millions.block')

  return (
    <div
      className={tm(
        'relative -ml-[50%] h-10 w-[200%] overflow-scroll md:h-16 lg:-ml-[10%]',
        className,
      )}
    >
      <div className="absolute left-0 top-0 flex w-fit">
        {impacts.map(impact => (
          <div className="flex" key={impact.color}>
            <Icon
              icon={impact.icon}
              className={tm(
                'h-10 w-10 rounded-full p-2 md:h-12 md:w-12 md:p-3',
                `bg-${impact.color}`,
              )}
            />
            <span
              className={tm(
                'flex h-10 items-center whitespace-nowrap rounded-full px-6 py-3 text-base font-semibold leading-[28px] md:h-12 md:text-lg md:leading-10',
                `bg-${impact.color}`,
              )}
            >
              {t(impact.content)}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export interface TenMillionsProps {}

export default function TenMillions() {
  const { t } = useTranslation('ten-millions.block')

  return (
    <div className="flex flex-col gap-14 overflow-hidden bg-black px-6 py-14 md:px-20">
      <ImpactRow impacts={impacts1} />
      <h2 className="text-center font-default text-[32px] font-semibold leading-[40px] -tracking-[1.5px] text-white md:text-[40px] md:leading-[48px]">
        {t('10m.title')}
      </h2>
      <ImpactRow impacts={impacts2} className="-ml-[45%] lg:-ml-[15%]" />
    </div>
  )
}
